var NAMESPACE = 'td';

var InputGroup = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-input-group" }, [_vm.$slots.prepend ? _c('div', { staticClass: "td-input-group__prepend" }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm.$slots.append ? _c('div', { staticClass: "td-input-group__append" }, [_vm._t("append")], 2) : _vm._e()], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-input-group'
};

var InputGroupButton = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('a', { staticClass: "td-input__button", class: { 'is-disabled': _vm.disabled }, attrs: { "href": "javascript:;" } }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-input-group-button',

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

InputGroup.install = function (Vue) {
  Vue.component(InputGroup.name, InputGroup);
  Vue.component(InputGroupButton.name, InputGroupButton);
};

export default InputGroup;
export { InputGroupButton };
